import { FC } from 'react';
import { StoreOrder } from '../../../SharedTypes/Models';
import { Loader } from '../../Loader/Loader';

import './SlideInHeader.scss';

export type Props = {
	isSaving: boolean;
	formValues: StoreOrder | null;
	buttonText: string;
	handleSlideIn: () => void;
	handleSubmit: () => void;
};

export const SlideInHeader: FC<Props> = ({
	isSaving,
	formValues,
	buttonText,
	handleSlideIn,
	handleSubmit,
}) => {
	const isCancelled = formValues?.dateCancelled;

	return (
		<div className="c-slideInHeader">
			<div className="c-slideInHeader__wrapper">
				<div className="left-button" onClick={() => handleSlideIn()}>
					Annuller
				</div>

				<button
					className={`right-button ${isCancelled ? 'right-button--cancelled' : ''} ${isSaving ? 'right-button--loading' : ''}`}
					onClick={() => handleSubmit()}
				>
					{isSaving ? (
						<>
							<span className="right-button__text">
								<Loader />
							</span>
						</>
					) : (
						<>
							<span className="right-button__icon">+</span>
							<span className="right-button__text">{buttonText}</span>
						</>
					)}
				</button>
			</div>
		</div>
	);
};
